module.exports = __webpack_public_path__ + "img/failOrder.7ccf16d0.png";